<h1 mat-dialog-title>
  <fa-icon [icon]="data.eicon" class="mr-4"></fa-icon>{{data.teitl | translate}}
</h1>
@if (data.neges) {
  <mat-dialog-content>
    @if (data.negesGwall) {
      <ul class="neges-gwall steil-rhestr">
        <li>
          {{ data.negesGwall | translate }}
        </li>
      </ul>
    }
    <p>{{data.neges | translate}}</p>
  </mat-dialog-content>
}
<mat-dialog-actions class="mat-mdc-dialog-actions">
  <button mat-raised-button color="primary" (click)="clicIa()">{{data.botwmia | translate}}</button>
  <button mat-flat-button (click)="clicNa()">{{data.botwmna | translate}}</button>
</mat-dialog-actions>